import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@20.14.15_encoding@0.1.13_eslint@9.9.1_jiti@1.21_gh7q6dsbo7qvduh23j5jidcgke/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}